export { default as TableEditPlugin } from './plugin/TableEditPlugin';
